<template>
  <div v-if="annotators.length">
    <Select2 :options="selectOptions" v-model="selectedIds" @select="select($event)" :settings="{multiple: true}" />
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Select2 from 'v-select2-component'

  export default {
    name: 'AnnotatorSelect',
    props: ['selected'],
    data(){
      return {
        selectedIds: this.selected
      }
    },
    components: {
      Select2
    },
    mounted() {
      this.$store.dispatch('loadAnnotators')
    },
    computed: {
      ...mapState({
        annotators: state => state.common.annotators
      }),
      selectOptions(){
        return this.annotators.map(annotator => {
          return {
            id: annotator.id,
            text: annotator.name
          }
        }).sort((a, b) => (a.text > b.text) ? 1 : -1)
      }
    },
    methods: {
      select(){
        let selectedObjects = this.annotators.filter(annotator => this.selectedIds.includes(annotator.id.toString()))
        this.$emit('select', selectedObjects)
      }
    }
  }
</script>

